export const SET_SHOW_LOADING_ADVANCEMENTS = 'SET_SHOW_LOADING_ADVANCEMENTS';
export const SET_ADVANCEMENT_SIMULATION = 'SET_ADVANCEMENT_SIMULATION';
export const SET_ADVANCEMENT_STATUS = 'SET_ADVANCEMENT_STATUS';
export const SET_ADVANCEMENT_DETAILS = 'SET_ADVANCEMENT_DETAILS';
export const RESET_ADVANCEMENT_DETAILS = 'RESET_ADVANCEMENT_DETAILS';
export const SET_ADVANCEMENT_ERROR = 'SET_ADVANCEMENT_ERROR';
